import { Dayjs } from "dayjs"
import { IFeature } from "./feature.types"

export class Feature implements IFeature {
  constructor(
    public id: number,
    public name: string,
    public enabled: boolean,
    public squadName: string,
    public description: string | null,
    public createdAt: Dayjs | null = null,
    public updatedAt: Dayjs | null = null,
  ) {}
}
